import React from 'react'
import { Box, CircularProgress, Typography, Container, Stack } from '@mui/material'
import { brandColors } from '../Color/Color'
import { fontLetterSpacings, fontLineHeights, fontSizes } from '../Typography/TypographyStyles'
import Logo from '../../../assets/images/EngagementAppLogo.png'

interface PageLoadingProps {
  message?: string
  subMessage?: string
}

const PageLoading: React.FC<PageLoadingProps> = ({
  message = 'Loading...',
  subMessage = 'Please wait while we prepare your content',
}) => {
  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'white',
      }}
      borderRadius={2}
      boxShadow={1}
    >
      <Container maxWidth='sm'>
        <Stack spacing={4} alignItems='center' justifyContent='center' sx={{ textAlign: 'center' }}>
          <Box
            component='img'
            src={Logo}
            alt='Engagement App Logo'
            sx={{
              maxWidth: 200,
              opacity: 0.8,
              animation: 'pulse 2s infinite',
              '@keyframes pulse': {
                '0%, 100%': { transform: 'scale(1)' },
                '50%': { transform: 'scale(1.05)' },
              },
            }}
          />

          <CircularProgress
            sx={{
              color: brandColors.greenTelus,
              marginTop: 2,
            }}
          />

          <Typography
            variant='h4'
            sx={{
              color: 'rgba(0,0,0,0.7)',
              fontSize: fontSizes.size24,
              fontWeight: 600,
              letterSpacing: fontLetterSpacings.normal,
              lineHeight: fontLineHeights.ratio9to8,
            }}
          >
            {message}
          </Typography>

          <Typography
            variant='body2'
            sx={{
              color: 'rgba(0,0,0,0.5)',
              fontSize: fontSizes.size16,
              letterSpacing: fontLetterSpacings.loose,
            }}
          >
            {subMessage}
          </Typography>
        </Stack>
      </Container>
    </Box>
  )
}

export default PageLoading
